(function () {
  'use strict';

  /**
   * TCB GA4 / GTM event helper. Pushes to dataLayer when present.
   * See docs/TCB-ECOSYSTEM-ROADMAP.md §12 Metrics.
   */
  function track(event, params) {
    if (!event) return;
    var payload = Object.assign({ event: event }, params || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params || {});
    }
    if (window.tcbAnalyticsDebug) {
      try {
        console.info('[tcbAnalytics]', payload);
      } catch (e) { /* ignore */ }
    }
  }

  window.tcbAnalytics = {
    track: track,
    finderStarted: function () { track('finder_started'); },
    finderCompleted: function (answers) {
      track('finder_completed', {
        facility: answers && answers.facility || '',
        equipment: answers && answers.equipment || '',
        budget: answers && answers.budget || ''
      });
    },
    finderEmailCaptured: function (email) {
      track('finder_email_captured', { has_email: !!email });
    },
    packageAddAllClicked: function (packageId, itemCount) {
      track('package_add_all_clicked', {
        package_id: packageId || '',
        item_count: itemCount || 0
      });
      track('package_add_all', {
        package_id: packageId || '',
        item_count: itemCount || 0
      });
    },
    packageTermsChecked: function (packageId) {
      track('package_terms_checked', { package_id: packageId || '' });
    },
    packageViewed: function (data) {
      track('package_viewed', data);
      track('package_view', data);
    },
    packageAddAllSuccess: function (data) { track('package_add_all_success', data); },
    packageAddAllFailed: function (data) { track('package_add_all_failed', data); },
    packageQuoteClicked: function (data) {
      track('package_quote_clicked', data);
      track('package_quote_click', data);
    },
    packageExpertClicked: function (data) { track('package_expert_clicked', data); },
    packageAddonSelected: function (data) { track('package_addon_selected', data); },
    packageAddonAdded: function (data) { track('package_addon_added', data); },
    packageAddIndividual: function (data) { track('package_add_individual', data); },
    packageAiAdvisorClick: function (data) { track('package_ai_advisor_click', data); },
    packageProductClick: function (data) { track('package_product_click', data); },
    packageVideoPlay: function (data) { track('package_video_play', data); },
    packageRelatedPackageClick: function (data) { track('package_related_package_click', data); },
    packageGuideClick: function (data) { track('package_guide_click', data); },
    quoteRequested: function (source, topic) {
      track('quote_requested', { source: source || 'unknown', topic: topic || '' });
    },
    formSubmitted: function (source, topic) {
      track('form_submitted', { form_source: source || 'unknown', topic: topic || '' });
    },
    newsletterSubscribed: function (source) {
      track('newsletter_subscribed', { source: source || 'footer' });
    },
    addToCart: function (data) {
      track('add_to_cart', {
        variant_id: (data && data.variant_id) || '',
        quantity: (data && data.quantity) || 1,
        source: (data && data.source) || 'unknown',
        item_id: (data && data.item_id) || '',
        item_name: (data && data.item_name) || '',
        price: (data && data.price) || '',
        vendor: (data && data.vendor) || ''
      });
    },
    removeFromCart: function (data) {
      track('remove_from_cart', {
        variant_id: (data && data.variant_id) || '',
        quantity: (data && data.quantity) || 1,
        source: (data && data.source) || 'unknown'
      });
    },
    viewCart: function (data) {
      track('view_cart', {
        item_count: (data && data.item_count) || 0,
        value: (data && data.value) || 0,
        currency: (data && data.currency) || 'USD',
        source: (data && data.source) || 'cart'
      });
    },
    beginCheckout: function (data) {
      track('begin_checkout', {
        item_count: (data && data.item_count) || 0,
        value: (data && data.value) || 0,
        currency: (data && data.currency) || 'USD',
        source: (data && data.source) || 'checkout'
      });
    },
    /* Purchase is primarily Shopify/GA4 native — theme helper for thank-you / confirmation only */
    purchase: function (data) {
      track('purchase', {
        transaction_id: (data && data.transaction_id) || '',
        value: (data && data.value) || 0,
        currency: (data && data.currency) || 'USD',
        item_count: (data && data.item_count) || 0,
        source: (data && data.source) || 'thank_you'
      });
    },
    callClick: function (data) {
      track('call_click', { source: (data && data.source) || 'unknown' });
    },
    emailClick: function (data) {
      track('email_click', { source: (data && data.source) || 'unknown' });
    },
    financingClick: function (data) {
      track('financing_click', {
        source: (data && data.source) || 'unknown',
        provider: (data && data.provider) || 'manual_finance_review'
      });
    },
    requestQuote: function (source, topic) {
      track('request_quote', { source: source || 'unknown', topic: topic || '' });
      track('quote_requested', { source: source || 'unknown', topic: topic || '' });
    },
    advisorOpened: function (data) {
      track('advisor_opened', {
        source: (data && data.source) || 'unknown',
        placement: (data && data.placement) || ''
      });
      track('ai_advisor_start', {
        source: (data && data.source) || 'unknown',
        placement: (data && data.placement) || ''
      });
    },
    finderOpened: function (data) {
      track('finder_opened', { source: (data && data.source) || 'unknown' });
      track('equipment_finder_start', { source: (data && data.source) || 'unknown' });
    },
    /* Acquisition layer — no PII. See data/acq and FORM_EVENT_SPEC. */
    quotePageView: function (data) { track('quote_page_view', data || {}); },
    quoteCtaClick: function (data) { track('quote_cta_click', data || {}); },
    rfqUploadStart: function (data) { track('rfq_upload_start', data || {}); }
  };
})();
